import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";

export default function DevirKalitedenGecmeyen() {
  const columns = [
    { key: "tarih", label: "Devir Tarihi" },
    { key: "urun_kodu", label: "Ürün Kodu", mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "renk", label: "Renk" },
    { key: "aciklama", label: "Ürün Açıklaması" },
    { key: "devir_adet", label: "Devir Adet", num: true },
    { key: "notlar", label: "Notlar" },
  ];
  const fields = [
    { key: "tarih", label: "Devir Tarihi", type: "date", required: true },
    { key: "urun_kodu", label: "Ürün Kodu", type: "product", required: true, span: 2, fills: { kalip_kodu: "kalip_kodu", renk: "renk", aciklama: "aciklama" } },
    { key: "kalip_kodu", label: "Kalıp Kodu (otomatik)", type: "text", readOnly: true },
    { key: "renk", label: "Renk (otomatik)", type: "text", readOnly: true },
    { key: "aciklama", label: "Ürün Açıklaması (otomatik)", type: "text", readOnly: true, span: 2 },
    { key: "devir_adet", label: "Kaliteden Geçmeyen Devir Adet", type: "number", required: true },
    { key: "notlar", label: "Notlar", type: "textarea", span: 2 },
  ];
  return (
    <>
      <PageHeader title="Kaliteden Geçmeyen Devir"
        subtitle="Ürün koduna göre manuel devir girişi. Devir tarihinden önceki üretimler sayılmaz; kaliteden geçen adetler önce devirden düşülür." />
      <CrudTable endpoint="/entity/kg_devir" columns={columns} fields={fields} titleSingular="Devir Kaydı"
        printTitle="Kaliteden Geçmeyen Devir" dateField="tarih" exportKind="kg_devir" />
    </>
  );
}
